/**
 * Lightweight loading fallback used by <Suspense> while lazy-loaded route
 * chunks are fetched. Intentionally minimal — first paint must not wait.
 */
import { Loader2 } from "lucide-react";

export default function RouteFallback() {
  return (
    <div
      className="min-h-[60vh] w-full flex items-center justify-center bg-rp-bg text-rp-textDim"
      data-testid="route-fallback"
      role="status"
      aria-live="polite"
    >
      <Loader2 className="h-5 w-5 animate-spin text-rp-accent" />
      <span className="ml-2 text-xs font-mono">Loading…</span>
    </div>
  );
}
